import { z } from 'zod';

// Warehouse was already on Zod 4.1.12. Retain its type and safe-integer wording.
z.config({
  customError: issue => {
    if (
      issue.code === 'invalid_type' &&
      typeof issue.input === 'number' &&
      !Number.isFinite(issue.input) &&
      !Number.isNaN(issue.input)
    ) {
      return `Invalid input: expected ${issue.expected}, received number`;
    }
    if (
      issue.code === 'too_big' &&
      issue.origin === 'int' &&
      issue.maximum === Number.MAX_SAFE_INTEGER
    ) {
      return `Too big: expected int to be <${Number.MAX_SAFE_INTEGER}`;
    }
    if (
      issue.code === 'too_small' &&
      issue.origin === 'int' &&
      issue.minimum === Number.MIN_SAFE_INTEGER
    ) {
      return `Too small: expected int to be >${Number.MIN_SAFE_INTEGER}`;
    }
    return undefined;
  },
});
